import { render, staticRenderFns } from "./borrow-history.vue?vue&type=template&id=00414560"
import script from "./borrow-history.vue?vue&type=script&lang=ts"
export * from "./borrow-history.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports